(function () {
	'use strict';

	var checkGroupPermission = function (user, siteName, requiredPermission) {
		var parts = requiredPermission.split('/');
		var type_ = parts[1],
			value = parts[2],
			subType_ = parts[3];
		var matchGroup = function (x) {
			return (
				(type_ === 'smart' && type_ === x.type && value === x.smartType) ||
				(type_ === 'custom' && type_ === x.type && value === x.name)
			);
		};

		if (subType_ == null) {
			return user.localAccess.groups.some(matchGroup);
		} else if (subType_ === 'role') {
			var role = parts[4];
			return user.localAccess.groups.some(function (x) {
				return (
					matchGroup(x) &&
					x.roles.some(function (y) {
						return y === role;
					})
				);
			});
		} else if (subType_ === 'permission') {
			var permission = parts[4];
			return user.localAccess.groups.some(function (x) {
				return (
					matchGroup(x) &&
					x.permissions.some(function (y) {
						return y === permission;
					})
				);
			});
		}
		return false;
	};

	var checkRolePermission = function (user, siteName, requiredPermission) {
		var parts = requiredPermission.split('/');
		var role = parts[1];
		var type_ = parts[2];

		if (type_ == null) {
			return user.localAccess.roles.has(role);
		} else if (type_ === 'location') {
			var locationId = parts[3];
			var access = user.localAccess.locations.get(locationId) || { roles: [] };
			return access.roles.some(function (x) {
				return x === role;
			});
		}
		return false;
	};

	var checkPermissionPermission = function (user, siteName, requiredPermission) {
		var parts = requiredPermission.split('/');
		var permission = parts[1],
			type_ = parts[2];

		if (type_ == null) {
			return user.localAccess.permissions.has(permission);
		} else if (type_ === 'location') {
			var locationId = parts[3];
			var access = user.localAccess.locations.get(locationId) || { permissions: [] };
			return access.permissions.some(function (x) {
				return x === permission;
			});
		}
		return false;
	};

	const permissionCheckers = {
		permission: checkPermissionPermission,
		group: checkGroupPermission,
		role: checkRolePermission
	};

	const hasPermission = function (user, siteName, requiredPermission) {
		let parts = requiredPermission.split('/');
		let accessType = parts[0];
		let permissionChecker =
			permissionCheckers[accessType] ||
			function () {
				return false;
			};

		try {
			return permissionChecker(user, siteName, requiredPermission);
		} catch (err) {
			return false;
		}
	};

	const checkPermission = function (siteName, user, requiredPermission) {
		return new Promise(function (resolve, reject) {
			if (requiredPermission.includes('|')) {
				let permissions = requiredPermission.split('|');
				if (permissions.some(p => hasPermission(user, siteName, p))) {
					resolve(true);
				} else {
					reject(false);
				}
			} else {
				if (hasPermission(user, siteName, requiredPermission)) {
					resolve(true);
				} else {
					reject(false);
				}
			}
		});
	};

	module.exports = { checkPermission, hasPermission };
})(typeof module !== 'undefined' && module.exports);
